/**
 * NOTE: This page is similar to the admin page but might be accessed by non-admin users.
 */
import React from "react";

import { withAppLayout } from "components/app_layout/AppLayout";
import { DetailsPage } from "components/app_layout/DetailsLayout";
import { FilterableDocuments } from "components/documents/FilterableDocuments";
import { FilterablePendingDocuments } from "components/documents/FilterablePendingDocuments";
import { UploadDocuments } from "components/documents/UploadDocuments";
import { ALL_DOCUMENT_COLUMNS, isAllDocumentTypesUser } from "components/documents/utils";
import Button from "components/ui/button/Button";
import { assertCurrentUser } from "lib/currentUser";
import { useDocuments } from "lib/hooks/api/admin/useDocuments";

import css from "./UploadDocumentPage.module.scss";

export enum PageState {
  HOME,
  UPLOAD,
  PREVIOUS_UPLOADS,
}

function UploadDocumentPage(): JSX.Element {
  const [pageState, setPageState] = React.useState<PageState>(PageState.HOME);

  const handleGoBack = () => {
    setPageState(PageState.HOME);
  };

  const renderPage = () => {
    switch (pageState) {
      case PageState.UPLOAD:
        return <UploadDocuments userId={assertCurrentUser().guid} />;
      case PageState.PREVIOUS_UPLOADS:
        return (
          <>
            <FilterableDocuments
              defaultColumns={ALL_DOCUMENT_COLUMNS.filter((c) => c.field !== "signalScore")}
              documentProvider={useDocuments}
              disablePreview
            />
            {/* Enable pending uploads view for HI-TECH or admins */}
            {(isAllDocumentTypesUser() || assertCurrentUser().admin) && (
              <FilterablePendingDocuments />
            )}
          </>
        );
      default:
        return (
          <div className={css.buttonContainer}>
            <Button buttonType="secondary" onClick={() => setPageState(PageState.UPLOAD)}>
              Upload documents
            </Button>
            <Button buttonType="secondary" onClick={() => setPageState(PageState.PREVIOUS_UPLOADS)}>
              See previous uploads
            </Button>
          </div>
        );
    }
  };

  return (
    <DetailsPage className={css.content}>
      {pageState !== PageState.HOME && (
        <Button onClick={handleGoBack} className={css.backButton}>
          Go Back
        </Button>
      )}
      {renderPage()}
    </DetailsPage>
  );
}

export default withAppLayout(UploadDocumentPage, {
  pageName: "Upload Document",
});
